import {
  BaseModelBasicData,
  BaseModelLiteData,
  OrderItemData,
  ProductFamilyBasicData,
  ShoppingCartItemData,
  WebShopProductDetailsData,
  WebShopProductListData,
} from '../../../data/model';
import { ProductData } from '../types';

export class ProductDataConverter {
  public static fromBaseModelBasicData(
    data: BaseModelBasicData,
    canBePurchased: boolean,
    configurationCode?: string,
    price?: number,
    quantity?: number,
  ): ProductData {
    return {
      brand: data.brandName,
      canBePurchased,
      configurationCode,
      id: data.id,
      name: data.displayName,
      price,
      quantity,
    };
  }

  public static fromBaseModelLiteData(
    familyData: ProductFamilyBasicData,
    data: BaseModelLiteData,
    canBePurchased: boolean,
    listName?: string,
    listPosition?: number,
  ): ProductData {
    return {
      brand: familyData.brand,
      canBePurchased,
      configurationCode: data.predefinedConfiguration?.code,
      id: data.id,
      listName,
      listPosition,
      name: data.name,
      quantity: 1,
    };
  }

  public static fromOrderItemData(data: OrderItemData, discountCode?: string): ProductData {
    return {
      brand: data.brandName,
      // An item can only end up in an order if it is purchasable
      canBePurchased: true,
      configurationCode: data.configurationCode,
      discount: data.discountAmountWithTax.amount,
      discountCode,
      id: data.productOriginId ?? data.baseModelId,
      name: data.name,
      price: data.price.amount,
      quantity: data.quantity,
    };
  }

  public static fromProductFamilyBasicData(
    data: ProductFamilyBasicData,
    listName?: string,
    listPosition?: number,
  ): ProductData {
    return {
      brand: data.brand,
      // A product family is a grouping, not a sellable item
      canBePurchased: false,
      listName,
      listPosition,
      name: data.name,
      quantity: 1,
    };
  }

  public static fromShoppingCartItemData(data: ShoppingCartItemData, discountCode?: string): ProductData {
    return {
      brand: data.baseModel.brandName,
      // An item can only end up in the shopping cart if it is purchasable
      canBePurchased: true,
      configurationCode: data.code,
      discount: data.discountAmountWithTax.amount,
      discountCode,
      id: data.baseModel.productOriginId ?? data.baseModel.id,
      name: data.baseModel.name,
      price: data.salePriceWithTax.amount,
      quantity: data.quantity,
    };
  }

  public static fromWebShopProductDetailsData(
    data: WebShopProductDetailsData,
    configurationCode: string,
    price: number,
    quantity: number,
  ): ProductData {
    return {
      brand: data.brandName,
      // Web shop products are purchasable by definition
      canBePurchased: true,
      configurationCode,
      id: data.baseModelId,
      name: data.name,
      price,
      quantity,
    };
  }

  public static fromWebShopProductListData(
    data: WebShopProductListData,
    listName?: string,
    listPosition?: number,
  ): ProductData {
    return {
      brand: data.brandName,
      // Web shop products are purchasable by definition
      canBePurchased: true,
      configurationCode: data.listingConfigurationCode,
      id: data.baseModelId,
      listName,
      listPosition,
      name: data.name,
      price: data.lowestPrice.amount,
      quantity: 1,
    };
  }
}
